import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { Url } from '../../Services/Api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({
    isInitializing: true,
    isLoggedIn: false,
    token: null,
    role: null, // Only store role object { _id, name }
    permissions: []
  });

  const storeAuthData = ({ token, role }) => {
    sessionStorage.setItem('authToken', token);
    setAuth({
      isInitializing: false,
      isLoggedIn: true,
      token,
      role,
      permissions: []
    });
  };

  const logout = () => {
    sessionStorage.removeItem('authToken');
    setAuth({
      isInitializing: false,
      isLoggedIn: false,
      token: null,
      role: null,
      permissions: []
    });
  };

  useEffect(() => {
    const token = sessionStorage.getItem('authToken');
    if (token) {
      setAuth(prev => ({
        ...prev,
        token,
        isLoggedIn: true
      }));
    } else {
      setAuth(prev => ({
        ...prev,
        isInitializing: false
      }));
    }
  }, []);

  useEffect(() => {
    const fetchRoleAndPermissions = async () => {
      try {
        const res = await axios.get(`${Url}/api/auth/permissions`, {
          headers: {
            Authorization: `Bearer ${auth.token}`
          }
        });

        const { roleId, roleName, permissions } = res.data;

        setAuth(prev => ({
          ...prev,
          isInitializing: false,
          isLoggedIn: true,
          role: { _id: roleId, name: roleName },
          permissions
        }));
      } catch (error) {
        console.error('Error fetching role:', error);
        logout();
      }
    };

    if (auth.token && !auth.role) {
      fetchRoleAndPermissions();
    }
  }, [auth.token]);

  return (
    <AuthContext.Provider value={{ auth, storeAuthData, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
